<div class="flex flex-col">
  <ng-container *ngIf="heatingSchedule$ | async | ready as heatingSchedule">
    <div data-at-programs class="programs flex flex-row flex-wrap gap-[30px]">
      <ng-container *ngFor="let mode of temperatureLevelsModes">
        <vi-program-item
          *ngIf="mode"
          [program]="mode.feature | temperatureLevelModeName"
          [hasTemperature]="mode?.properties?.temperature?.value !== undefined"
        >
          <vi-text name *ngIf="!(mode | executable: 'setTemperature')" class="flex-1">
            {{ mode.feature | temperatureLevelModeName | translateOperatingProgram }}
          </vi-text>
          <app-temperature-select
            item
            *ngIf="mode | executable: 'setTemperature'"
            id="program-{{ mode.feature | temperatureLevelModeName }}"
            [title]="mode.feature | temperatureLevelModeName | translateOperatingProgram"
            [rangeDefinition]="mode | constraints: 'setTemperature':'targetTemperature'"
            [value]="mode.properties?.temperature?.value"
            (valueChange)="onProgramTemperatureChange($event, mode.feature)"
          ></app-temperature-select>
        </vi-program-item>
      </ng-container>
    </div>
    <app-timemanager class="gap" (scheduleChange)="onScheduleChange($event, heatingSchedule)">
    </app-timemanager>

    <div class="programs-container gap flex flex-row justify-between items-center">
      <button
        mat-stroked-button
        color="primary"
        gtm="onOpen"
        gtmAction="Multiple days selection dialog"
        gtmCategory="heatingSchedule"
        id="edit-multiple-dhw-btn"
        data-at-edit-multiple
        (click)="onEditMultipleDays()"
      >
        {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
      </button>
    </div>
  </ng-container>
</div>
